import { cumulativeRgbPlotData } from "../../colorplot"
import { ColorIndex } from "../../colorspace"
type CreateCumulativeRgbRequest = {
    colorIndex: ColorIndex
    //abortSignal: AbortSignal
}

export type CumulativeRGB = ReturnType<typeof cumulativeRgbPlotData> & {
    cumulativeIndex: Uint32Array
}

export const createCumulativeRgb = async (req: CreateCumulativeRgbRequest) => {
    const worker = new Worker(new URL("./createCumulativeRgb.worker.ts", import.meta.url))
    const output = await new Promise<CumulativeRGB>((resolve, reject) => {
        worker.addEventListener("message", (message) => {
            if (message.data) {
                resolve(message.data)
            } else {
                reject()
            }
            worker.terminate()
        })

        worker.postMessage({
            ...req,
        })
    })
    return output
}
